import {
  FilterGroupItem,
  isFilterGroup,
} from 'services/providers/bapi/entities/filters/types'
import { isFilterGroupWithoutValues } from './isFilterGroupWithoutValues'

const SALE_FILTER_SLUG = 'sale'
const IS_NEW_FILTER_SLUG = 'isNew'

export const filterOutByPredefinedSlug = (filterGroup: FilterGroupItem) => {
  if (isFilterGroupWithoutValues(filterGroup)) {
    return false
  }

  const key = isFilterGroup(filterGroup)
    ? filterGroup.filterGroupSlug
    : filterGroup.slug

  switch (true) {
    case key === SALE_FILTER_SLUG:
    case key === IS_NEW_FILTER_SLUG:
      return false
    default:
      return true
  }
}
